import { User, useConfigCatClient, useFeatureFlag } from 'configcat-react';

import type { FeatureToggles } from '@/configuration/featureToggle/featureToggles';
import { useAccountStore } from '@/stores/accountStore';

export type FeatureTogglesT = (typeof FeatureToggles)[keyof typeof FeatureToggles];

export const useFeatureToggle = (featureToggleId: FeatureTogglesT, defaultValue: string | boolean | number = false) => {
    const { userProfile } = useAccountStore();
    const userObject = new User(userProfile?.account ?? 'NO_IDENTIFIER');
    const client = useConfigCatClient();
    const result = useFeatureFlag(featureToggleId, defaultValue, userObject);

    if (import.meta.env.DEV) {
        client.setOffline();
        return { value: true, loading: false };
    }
    return result;
};
